// extracted by mini-css-extract-plugin
export default {"packagesSection":"Packages_packagesSection__t0UIU"};